import './assets/styles/main.scss'
import './assets/styles/animations.scss'

import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
